import { CreditCard, Sparkles, Repeat } from 'lucide-react';

const money = (n) => `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

function NoPaymentCard({ billing, processing, onSubscribe }) {
  const managed = billing.category === 'managed';
  let text = 'Pricing is discussed in the chat below before anything is charged.';
  if (billing.pricing_label === 'Free') text = 'No charge — chat freely with our AI and a human if needed.';
  if (billing.category === 'web') text = `Project price ${money(billing.base_price)}. After your free consultation, a 50% non-refundable deposit (${money(billing.base_price / 2)}) starts the build.`;
  return (
    <div className="mb-3 p-3 bg-[#b026ff]/10 rounded-lg border-2 border-[#b026ff]" data-testid="billing-no-payment">
      <p className="text-[#b026ff] text-sm font-bold mb-1 glow flex items-center gap-1"><Sparkles size={14} /> {billing.pricing_label || 'No payment required'}</p>
      <p className="text-[#00f0ff]/80 text-xs">{managed ? 'Monthly plan: hosting, 99.9% uptime, backups and SSL/content upkeep.' : text}</p>
      {managed && (
        <button onClick={onSubscribe} disabled={processing} data-testid="ticket-subscribe-button"
          className="mt-3 w-full px-4 py-2 btn-primary text-white font-bold rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
          <Repeat size={16} /> {processing ? 'Processing...' : `Subscribe ${money(billing.base_price)}/mo`}
        </button>
      )}
    </div>
  );
}

function Breakdown({ billing }) {
  if (!billing.diagnostic_fee_applies) {
    return <p className="text-[#00f0ff]/80 text-xs">Total: {money(billing.base_price)} · no diagnostic fee</p>;
  }
  return (
    <div className="space-y-1 text-xs">
      <div className="flex justify-between text-[#00f0ff]/80"><span>Service total</span><span>{money(billing.base_price)}</span></div>
      <div className={`flex justify-between ${billing.diagnostic_paid ? 'text-[#00ff00]' : 'text-[#ff00ff]'}`}>
        <span>$75 diagnostic {billing.diagnostic_paid ? '(paid)' : '(first)'}</span><span>−{money(billing.diagnostic_fee)}</span>
      </div>
      <div className="flex justify-between text-[#00f0ff] font-bold border-t border-[#00f0ff]/30 pt-1">
        <span>Balance when fixed</span><span>{money(Math.max(0, billing.base_price - billing.diagnostic_fee))}</span>
      </div>
    </div>
  );
}

export function TicketBillingCard({ billing, processing, onPay, onSubscribe }) {
  if (!billing) return null;
  if (!billing.requires_payment) return <NoPaymentCard billing={billing} processing={processing} onSubscribe={onSubscribe} />;
  const due = billing.next_payment;
  const payLabel = due?.type === 'diagnostic' ? `Pay ${money(due.amount)} diagnostic` : `Pay ${money(due?.amount || 0)}`;
  return (
    <div data-testid="billing-card">
      <div className="mb-3 p-3 bg-[#ff00ff]/10 rounded-lg border border-[#ff00ff]/30">
        <p className="text-[#00f0ff] text-sm font-semibold mb-2">Service pricing</p>
        <Breakdown billing={billing} />
      </div>
      {billing.paid_in_full ? (
        <p className="text-[#00ff00] text-sm font-bold text-center" data-testid="billing-paid-in-full">✓ Paid in full</p>
      ) : (
        <button onClick={onPay} disabled={processing || !due}
          className="w-full px-6 py-3 btn-primary text-white font-bold rounded-lg flex items-center justify-center space-x-2 disabled:opacity-50"
          data-testid="stripe-checkout-button">
          <CreditCard size={20} />
          <span>{processing ? 'Processing...' : `${payLabel} with Stripe`}</span>
        </button>
      )}
    </div>
  );
}
